const crossfadeDurationMs = 225;
const wrapper = "_35swzl89sr";
const toggle = "_35st1aiop7t";
const transitionWrapper = "_35stcasss3";
const dropzoneContainer = "_35sdaofdyt";

export { crossfadeDurationMs, dropzoneContainer, toggle, transitionWrapper, wrapper };
import "./organism.facit-container.style.linaria.module.css";
//# sourceMappingURL=organism.facit-container.style.js.map
